import React from 'react';
import { ApplicationView } from '@aha-app/mvc';
import {
  type LayoutComponent,
  type EditorPlugin,
  type FullScreenProvider,
  type AhaEditor,
} from '@aha-app/aha-editor-v2';
import Topbar from './Topbar';
import AhaFullScreenProvider, {
  type FullScreenDelegate,
} from '../FullScreen/AhaFullScreenProvider';

export interface FullScreenProviderProps {
  fullScreenURL?: string;
  nonFullScreenURL?: string;
  supportsFullscreen?: boolean;
}

const FullScreenTopBarPluginFactory = (
  delegate: FullScreenDelegate
): EditorPlugin => {
  let ahaEditor: AhaEditor;

  const FullScreenTopBar: LayoutComponent = () => {
    const controller = ahaEditor.controller;
    if (!controller.state.pluginState.isFullScreen) {
      return null;
    }

    return (
      <Topbar
        onClose={() => {
          const provider = ahaEditor.getProvider('fullScreen');
          if (!provider) {
            return;
          }
          provider.onSetFullScreen(false);
        }}
        enclosingElement={delegate.getEnclosingElement?.()}
      />
    );
  };

  let fullScreenProvider: FullScreenProvider;

  return {
    name: 'Full screen top bar layout component',
    handlers: {
      onInit(_ahaEditor) {
        ahaEditor = _ahaEditor;
        fullScreenProvider = new AhaFullScreenProvider(ahaEditor, delegate);

        ahaEditor.registerProviderPlugin(fullScreenProvider);
      },
    },
    layoutComponent: {
      location: 'above',
      Component: ApplicationView(FullScreenTopBar),
    },
  };
};

export default FullScreenTopBarPluginFactory;
